export class PageableUserRequest {

  page: number;
  size: number;
  sortBy: string;
  sortDir: string;
  key: string;
  role: string;
}